/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandGravatar = createReactComponent("outline", "brand-gravatar", "IconBrandGravatar", [["path", { "d": "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714", "key": "svg-0" }]]);

export { IconBrandGravatar as default };
//# sourceMappingURL=IconBrandGravatar.mjs.map
